import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface Empresa {
  id: number;
  nome: string;
  nome_fantasia?: string | null;
  comissao_representante: string | number;
  cnpj?: string | null;
  uf?: string | null;
  cep?: string | null;
  rua?: string | null;
  numero?: string | null;
  bairro?: string | null;
  cidade?: string | null;
  telefone?: string | null;
  email?: string | null;
  status?: number | null;
}

export interface EmpresaResponse {
  data: Empresa[];
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

@Injectable({
  providedIn: "root",
})
export class EmpresaService {
  private apiUrl = environment.domain.api + "/representante/empresa";

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem("token");
    return new HttpHeaders({
      "Content-Type": "application/json",
      token: token || "",
    });
  }

  listarDoRepresentante(
    page: number = 1,
    filtros?: any
  ): Observable<EmpresaResponse> {
    let params: any = {
      page: page.toString(),
    };

    if (filtros) {
      Object.keys(filtros).forEach((key) => {
        if (
          filtros[key] !== null &&
          filtros[key] !== undefined &&
          filtros[key] !== ""
        ) {
          params[key] = filtros[key];
        }
      });
    }

    return this.http.get<EmpresaResponse>(this.apiUrl + "/doRepresentante", {
      headers: this.getHeaders(),
      params: params,
    });
  }

  formatarCNPJ(cnpj: string | null | undefined): string {
    if (!cnpj || typeof cnpj !== "string") return "N/A";
    return cnpj.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      "$1.$2.$3/$4-$5"
    );
  }

  formatarTelefone(telefone: string | null | undefined): string {
    if (!telefone || typeof telefone !== "string") return "N/A";
    const cleaned = telefone.replace(/\D/g, "");
    if (cleaned.length === 11) {
      return cleaned.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
    } else if (cleaned.length === 10) {
      return cleaned.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3");
    }
    return telefone;
  }

  formatarCEP(cep: string | null | undefined): string {
    if (!cep || typeof cep !== "string") return "N/A";
    return cep.replace(/^(\d{5})(\d{3})$/, "$1-$2");
  }

  formatarComissao(comissao: string | number | null | undefined): string {
    if (comissao === null || comissao === undefined) return "0%";

    const valor = parseFloat(comissao.toString());
    if (isNaN(valor)) return "0%";

    return valor.toFixed(2) + "%";
  }

  getStatusClass(status: number | string | null | undefined): string {
    if (status === null || status === undefined) {
      return "status-unknown";
    }
    const statusNum = Number(status);
    switch (statusNum) {
      case 1:
        return "status-active";
      case 0:
        return "status-inactive";
      default:
        return "status-unknown";
    }
  }

  getStatusIcon(status: number | string | null | undefined): string {
    if (status === null || status === undefined) {
      return "feather icon-help-circle";
    }
    const statusNum = Number(status);
    switch (statusNum) {
      case 1:
        return "feather icon-check-circle";
      case 0:
        return "feather icon-x-circle";
      default:
        return "feather icon-help-circle";
    }
  }

  getStatusText(status: number | string | null | undefined): string {
    if (status === null || status === undefined) {
      return "N/A";
    }
    const statusNum = Number(status);
    switch (statusNum) {
      case 1:
        return "Ativo";
      case 0:
        return "Inativo";
      default:
        return "Desconhecido";
    }
  }

  formatarEnderecoCompleto(empresa: any): { rua: string; cep: string } {
    const rua = empresa.rua || "";
    const numero = empresa.numero || "";
    const bairro = empresa.bairro || "";

    let enderecoRua = rua;
    if (numero) {
      enderecoRua += `, ${numero}`;
    }
    if (bairro) {
      enderecoRua += ` - ${bairro}`;
    }

    const cep = empresa.cep ? this.formatarCEP(empresa.cep) : "";

    return {
      rua: enderecoRua.trim(),
      cep: cep,
    };
  }

  updateStatusEmpresa(id: number, status: string | number) {
    return this.http.post(
      this.apiUrl + "/update",
      { id, status },
      { headers: this.getHeaders() }
    );
  }

  dashboardDoRepresentante() {
    return this.http.post(
      this.apiUrl + "/dashboard",
      {},
      { headers: this.getHeaders() }
    );
  }
}
